module.exports = __webpack_public_path__ + "img/living_commer_imgerror.dab4c998.png";